import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { hasPermission } from '../utils/permissions'
import { hasMobilePermission } from '../utils/mobileProfile'
import { useMobileWebProfile } from '../hooks/useMobileWebProfile'
import LoadingSpinner from './LoadingSpinner'

/**
 * Route guard — redirects workers without the required permission.
 * Admins (role_id = 1) pass on desktop; on mobile web, admin uses mobile permissions.
 */
export default function RequirePermission ({
  permission,
  permissions,
  children,
  redirectTo = '/painter/dashboard',
}) {
  const { user, loading } = useAuth()
  const { appliesMobileProfile, defaultRoute } = useMobileWebProfile()

  const codes = permissions || (permission ? [permission] : [])

  if (loading) {
    return <LoadingSpinner size="lg" className="py-12" />
  }

  const allowed = codes.some((code) => {
    if (appliesMobileProfile) {
      return hasMobilePermission(user, code)
    }
    return hasPermission(user, code)
  })

  if (!allowed) {
    return <Navigate to={appliesMobileProfile ? defaultRoute : redirectTo} replace />
  }

  return children
}
